var hamburgerTrigger = document.getElementById('hamburger_desktop');
var megaDesktopNav = document.getElementById('mega_desktop_nav');
var closeMega = document.getElementById('close_mega');


if(typeof hamburgerTrigger != "undefined" && hamburgerTrigger != null) {
    hamburgerTrigger.addEventListener('click', function(e){
        e.preventDefault();
    
        megaDesktopNav.classList.add('show');
    });
    
    closeMega.addEventListener('click', function(e){
        e.preventDefault();
    
        megaDesktopNav.classList.remove('show');
    });
}

document.addEventListener('DOMContentLoaded', function(){

    var selectVariant = document.querySelector('.product-form__input .select select');
    var messageWrapper = document.querySelector('.measurement-messages');

    if(typeof selectVariant !== 'undefined' && selectVariant != null ) {
        if(selectVariant.value == messageWrapper.dataset.variantOption) {
            messageWrapper.querySelector('.right-message').style.display = 'block';
            messageWrapper.querySelector('.wrong-message').style.display = 'none';
        } else {
            messageWrapper.querySelector('.right-message').style.display = 'none';
            messageWrapper.querySelector('.wrong-message').style.display = 'block';
        }

        messageWrapper.style.display = 'block';

        selectVariant.addEventListener('change', function(e){            
            if(e.target.value == messageWrapper.dataset.variantOption) {
                messageWrapper.querySelector('.right-message').style.display = 'block';
                messageWrapper.querySelector('.wrong-message').style.display = 'none';
            } else {
                messageWrapper.querySelector('.right-message').style.display = 'none';
                messageWrapper.querySelector('.wrong-message').style.display = 'block';
            }
        });

        console.dir(selectVariant.parentElement.parentElement.nextElementSibling);
    }

    // Menu Dropdown

    var menuItems = document.querySelectorAll('.has-panel > a');

    menuItems.forEach(function(item) {
        item.addEventListener('click', function(e){
            e.preventDefault();
            this.classList.toggle('active');
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    });

    var countrySelectors = document.querySelectorAll('.country-select-container');

    if(typeof countrySelectors != 'undefined' && countrySelectors != null) {
        countrySelectors.forEach(function(countrySelector) {
            countrySelector.addEventListener('click', function(){
                this.classList.toggle('open');
            });
        });        
    }
});

